import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CanonicalService {
  private canonicalLink: HTMLLinkElement | null = null;
  private isBrowser: boolean;
  private dont: boolean;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.dont =
      this.document.URL.includes('/articles') &&
      this.document.URL.includes('?lang=en');

    if (this.isBrowser) {
      this.setupCanonicalLink();
      this.listenToRouterEvents();
    }
  }

  private setupCanonicalLink() {
    this.canonicalLink = this.document.createElement('link');
    this.canonicalLink.setAttribute('rel', 'canonical');
    let url = this.document.URL;
    if (this.dont) url = url.replace('?lang=en', '');
    this.canonicalLink.setAttribute('href', url);

    this.document.head.appendChild(this.canonicalLink); // `appendChild` is safer than `append` for SSR compatibility
  }

  private listenToRouterEvents() {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        if (this.canonicalLink) {
          let url = this.document.URL;
          if (this.dont) url = url.replace('?lang=en', '');
          this.canonicalLink.setAttribute('href', url);
        }
      });
  }

  public setCanonicalUrl(url: string) {
    if (this.isBrowser && this.canonicalLink) {
      this.canonicalLink.setAttribute('href', url);
    }
  }
}
